import {apiWithToken} from '../../../systems/api/index';
import {API_URL} from '../../../systems/globalContant/index';

export default {
    getListTransaction: (filters) => apiWithToken.get(API_URL.LIST_TRANSACTION, {params: filters}, {loading: false}),
    exportCSV: (data) => apiWithToken.get(API_URL.EXPORT_CSV, {params: data}, {...data}),
    exportTransactionOrder: (data) => apiWithToken.get(API_URL.DEFAULT + `/orders/export-finali`, {params: data}, {...data}),
    refundAmount: (transactionId, data) => apiWithToken.put(API_URL.DEFAULT + `/transactions/${transactionId}/order-payment`, data),
};
